<template>
  <div>
   <v-row>
      <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12" class="pink">
      </v-col>
      </v-row>
      <v-row class="grey lighten-4" app>
    <v-col cols="12" xs="12" sm="12" md="5" lg="5" xl="5">
       <img class=" ml-14 pt-1" :src="require('../../assets/zaastry.png')" height="40"/>
    </v-col>
    <v-spacer></v-spacer>
    <v-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6" class="mr-5 d-none d-lg-flex d-xl-none">
      <v-row>
        <v-spacer></v-spacer>
         <v-icon large class="ml-14 pt-1"> mdi-shopping-outline </v-icon>
          <v-btn outlined class="mt-6 ml-4" small>0.00</v-btn>
      </v-row>
    </v-col>
      </v-row>
  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>